export const coverageStatusMap = {
    U: 'Without subsidy',
    R: 'With subsidy'
};

export const aperakStatusMap = {
    '0': 'Accepted',
    '1': 'Accepted with warning',
    '2': 'Not accepted',
    // '3': 'No confirmation',
    '3': 'Cancelled',
    '9': 'Cancelled',
    '99': 'Cancelled',
    '100': 'Manually added',
};

export const coverageClassMap = {
    U: 'coverage-without-subsidy',
    R: 'coverage-with-subsidy'
};

export const aperakClassMap = {
    '0': 'accepted',
    '1': 'accepted-with-warning',
    '2': 'not-accepted',
    // '3': 'no-confirm',
    '3': 'cancelled',
    '9': 'cancelled',
    '99': 'custom-cancelled',
    '100': 'manually-added'
};

export const timeUnitMap = {
    Dg: 'day',
    V: 'week',
    Mn: 'month',
};

/**
 * Format duration for prescription item
 * @param {Object} prescriptionItem
 * @returns {string|null}
 */
export function formatDuration(prescriptionItem) {
    if (!prescriptionItem?.timeValue) return null;
    const unit = timeUnitMap[prescriptionItem?.timeUnit] ?? prescriptionItem?.timeUnit;
    return `${prescriptionItem?.timeValue} ${unit}${prescriptionItem?.timeValue > 1 ? 's' : ''}`;
}

/**
 * Format issue date and time
 * @param {string|Date} issueTime
 * @returns {Object} { formattedDate, formattedTime }
 */
export function formatIssueDate(issueTime) {
    if (!issueTime) return { formattedDate: '', formattedTime: '' };
    const date = new Date(issueTime);
    const formattedDate = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    return { formattedDate, formattedTime };
}

/**
 * Format prescription item details
 * @param {Object} pi - prescription item
 * @returns {Object} { mainLine, detailsLine }
 */
export function formatPrescriptionDetails(pi) {
    if (!pi) return { mainLine: '', detailsLine: '' };

    const mainLine = `${pi?.distributedTradeName} ${pi?.strengthText ?? ''}`.trim();

    const controlClassMap = {
        0: 'Not classified',
        1: 'Class II',
        2: 'Class IV/V',
        3: 'Class III',
        4: 'Class IV',
        5: 'Class V',
        6: 'Class I'
    };

    const controlClassText = pi?.controlClassCode !== undefined
        ? controlClassMap[pi?.controlClassCode]
        : null;

    const detailsArray = [
        pi?.formText,
        pi?.packSizeText,
        pi?.numberOfPackages ? `${pi?.numberOfPackages} pack(s)` : null,
        controlClassText
    ].filter(Boolean);

    const detailsLine = detailsArray.join(' • ');

    return { mainLine, detailsLine };
}

/**
 * Get number of refills from prescription item
 * @param {Object} prescriptionItem
 * @returns {number}
 */
export function getRefills(prescriptionItem) {
    return prescriptionItem?.dispensingRepeatNumber ?? 0;
}

export const formatBoolean = (value, lang) => {
    if (value === true) return 'Yes'.translate(lang);
    if (value === false) return 'No'.translate(lang);
    return value ?? '-';
};